//apiService.js
import { t } from "i18next";
import { getFirebaseToken } from "./authService";

/**
 * Makes an authenticated API request.
 *
 * @param {string} url - The endpoint URL.
 * @param {string} [method='GET'] - HTTP method (GET, POST, etc.).
 * @param {object|null} [body=null] - Request payload.
 * @returns {Promise<object>} The parsed JSON response.
 * @throws {Error} Throws an error if the request fails.
 */
export const apiRequest = async (url, method = "GET", body = null, requireAuth = true) => {
  try {
    let authUrl = url;
    if (requireAuth) {
      const token = await getFirebaseToken();
      if (!token) throw new Error(t("errors.authFailed"));
      authUrl = `${url}?auth=${token}`;
    }

    const options = {
      method,
      headers: { "Content-Type": "application/json" },
      body: body ? JSON.stringify(body) : null,
    };

    const response = await fetch(authUrl, options);
    if (!response.ok) {
      throw new Error(t("errors.apiRequestFailed", { status: response.statusText }));
    }

    const jsonResponse = await response.json();
    return jsonResponse || {};
  } catch (error) {
    throw new Error(t("errors.apiRequestError", { url }));
  }
};
